export const refillSidebarVisibleStateKey = 'refillSidebarVisible';
export const refillSidebarDefaultValuesStateKey = 'refillSidebarDefaultValues';
export const dynamicTitleStateKey = 'dynamicTitle';
